import { entityPreviewRouteRef } from './routes';

import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

export const entityPreviewPlugin = createPlugin({
  id: 'entity-preview',
  routes: {
    entityPreview: entityPreviewRouteRef,
  },
});

export const EntityPreviewPage = entityPreviewPlugin.provide(
  createRoutableExtension({
    name: 'EntityPreviewPage',
    component: () =>
      import('./components/EntityPreviewPage').then(m => m.EntityPreviewPage),
    mountPoint: entityPreviewRouteRef,
  }),
);

export const EntityPreviewBanner = entityPreviewPlugin.provide(
  createComponentExtension({
    name: 'EntityPreviewBanner',
    component: {
      lazy: () =>
        import('./components/EntityPreviewBanner').then(
          m => m.EntityPreviewBanner,
        ),
    },
  }),
);
